import { TSearchParams, TSearchResults } from "@/types";

import API from "./api";

class SearchServiceClass {
	search(options: TSearchParams): Promise<TSearchResults> {
		return API.post(`search`, options).then((resp) => resp.data);
	}
}

const SearchService = new SearchServiceClass();
export default SearchService;
